/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * an updated workflow definition received in the Isolated Zone
 * @export
 * @interface WorkflowDefinition
 */
export interface WorkflowDefinition {
    /**
     * 
     * @type {number}
     * @memberof WorkflowDefinition
     */
    batchId?: number;
    /**
     * 
     * @type {Date}
     * @memberof WorkflowDefinition
     */
    createdAt: Date;
    /**
     * location/path of workflow definition file
     * @type {string}
     * @memberof WorkflowDefinition
     */
    definitionFile?: string;
    /**
     * identifier of workflow definition
     * @type {number}
     * @memberof WorkflowDefinition
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefinition
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefinition
     */
    status: WorkflowDefinitionStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof WorkflowDefinition
     */
    statusUpdatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof WorkflowDefinition
     */
    versionNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefinition
     */
    workflowType?: string;
}


/**
 * @export
 */
export const WorkflowDefinitionStatusEnum = {
    Received: 'Received',
    Validated: 'Validated',
    Failed: 'Failed',
    InProgress: 'In Progress',
    Rejected: 'Rejected',
    Completed: 'Completed'
} as const;
export type WorkflowDefinitionStatusEnum = typeof WorkflowDefinitionStatusEnum[keyof typeof WorkflowDefinitionStatusEnum];


/**
 * Check if a given object implements the WorkflowDefinition interface.
 */
export function instanceOfWorkflowDefinition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "statusUpdatedAt" in value;

    return isInstance;
}

export function WorkflowDefinitionFromJSON(json: any): WorkflowDefinition {
    return WorkflowDefinitionFromJSONTyped(json, false);
}

export function WorkflowDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowDefinition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'batchId': !exists(json, 'batch_id') ? undefined : json['batch_id'],
        'createdAt': (new Date(json['created_at'])),
        'definitionFile': !exists(json, 'definition_file') ? undefined : json['definition_file'],
        'id': json['id'],
        'name': json['name'],
        'status': json['status'],
        'statusUpdatedAt': (new Date(json['status_updated_at'])),
        'versionNumber': !exists(json, 'version_number') ? undefined : json['version_number'],
        'workflowType': !exists(json, 'workflow_type') ? undefined : json['workflow_type'],
    };
}

export function WorkflowDefinitionToJSON(value?: WorkflowDefinition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'batch_id': value.batchId,
        'created_at': (value.createdAt.toISOString()),
        'definition_file': value.definitionFile,
        'id': value.id,
        'name': value.name,
        'status': value.status,
        'status_updated_at': (value.statusUpdatedAt.toISOString()),
        'version_number': value.versionNumber,
        'workflow_type': value.workflowType,
    };
}

